import { render, staticRenderFns } from "./CollectionTable.vue?vue&type=template&id=4f1ef760&"
import script from "./CollectionTable.vue?vue&type=script&lang=js&"
export * from "./CollectionTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports